// extracted by mini-css-extract-plugin
export var aboveInput = "_jc-0";
export var actionButton = "_jc-5";
export var actionButtonContainer = "_jc-1";
export var actionIcon = "_jc-6";
export var aiInfoContainer = "_jc-2";
export var attachmentWrapper = "_jc-7";
export var bold = "_jc-3";
export var checkIcon = "_jc-8";
export var clickingRecipientBar = "_jc-11";
export var commentThreadSwitch = "_jc-a";
export var draftImage = "_jc-b";
export var draftImageContainer = "_jc-c";
export var draftImages = "_jc-e";
export var editButton = "_jc-g";
export var editor = "_jc-f";
export var editorContainer = "_jc-y";
export var editorErrorTooltipWrapper = "_jc-9";
export var headerDivider = "_jc-h";
export var icon = "_jc-i";
export var info = "_jc-j";
export var internal = "_jc-n";
export var internalDivider = "_jc-k";
export var internalMessage = "_jc-l";
export var messageInputCard = "_jc-m";
export var messageInputForm = "_jc-o";
export var messageInputFormInternal = "_jc-p";
export var options = "_jc-q";
export var publicMessageCustomer = "_jc-s";
export var publicMessageMerchant = "_jc-r";
export var removeImageButton = "_jc-d";
export var replyButtons = "_jc-t";
export var showSignatureButton = "_jc-u";
export var spinner = "_jc-v";
export var verticalButtonDivider = "_jc-4";
export var visibilitySelector = "_jc-w";
export var warning = "_jc-x";
export var wrappingText = "_jc-z";
export var writingInternalNoteTopBorder = "_jc-10";